export const providers = {
  icms: 1,
  exec: 2,
};

export const attachmentTypes = {
  objection: 1,
  decision: 2,
};

export const Urls = { judicialFees: 'https://cfee.moj.gov.sa/system.html' };